import Tag, { TagVariant } from '@atoms/Tag/Tag';
import { IFilterList } from '@models/IFilterList';
import SiteEnum from '@models/enums/SiteEnum';

const FilterList = ({
  filters,
  onSelect,
  selectedItemID,
  site,
}: IFilterList) => (
  <div className="tw-flex  tw-flex-wrap tw-justify-center tw-gap-2">
    {filters.map((filter) => (
      <Tag
        key={filter.id}
        onClick={() => onSelect(filter.id)}
        label={filter.label}
        isActive={selectedItemID === filter.id}
        largeText
        variant={site === SiteEnum.B2B ? TagVariant.Yellow : TagVariant.Grey}
      />
    ))}
  </div>
);

export default FilterList;
